import { render, staticRenderFns } from "./CustomerRole.vue?vue&type=template&id=0e66ebee&"
import script from "./CustomerRole.vue?vue&type=script&lang=js&"
export * from "./CustomerRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports